import React from "react";
import { convertDateFormat, groupBy, groupByTime } from "../../../../../Helpers/Chat/ChatHelper";
import { groupstatus } from "../../../../../Helpers/Chat/RecentChat";
import CreateTemplate from "./index";
import scrollComponent from "./Scroll/ScrollHOC";
import { GROUP_CHAT_PROFILE_UPDATED_NOTIFY } from "../../../../../Helpers/Chat/Constant";
import { convertUTCDateToLocalDate } from "../../../../WebChat/WebChatTimeStamp.js";
import DeletedMessage from "./Common/DeletedMessage";

const ChatTemplate = (props = {}) => {
    const iterateArrayOfTemplate = (chatMessages) => {
        if (!chatMessages) return null;

        const {
            rosterData: { data: rosterArray },
            groupMemberDetails,
            viewOriginalMessage,
            vCardData: { data } = {},
            jid,
            chatType,
            requestReplyMessage,
            messageAction,
            addionalnfo,
            deliveredType,
            handleTranslateLanguage,
            closeMessageOption,
            handleShowCallScreen,
        } = props;
        
        return chatMessages.map((msg) => {
            const {
                deleteStatus,
                msgId,
                msgBody,
                msgType,
                msgBody: { message_type = "" } = {}
            } = msg;
            if(Object.keys(msgBody).length === 0){
            if((msgType === "seen" || msgType === GROUP_CHAT_PROFILE_UPDATED_NOTIFY)) {
                const { publisherId, userId, profileUpdatedStatus } = msg;
                const notification = groupstatus(publisherId, userId, profileUpdatedStatus, rosterArray) || "";
                return (
                    <div key={msgId} id={msgId} className="chatStatusBar">
                        <span>{notification}</span>
                    </div>
                );
            }}
            return  deleteStatus === 0 ? (
            <CreateTemplate
                message_type={message_type}
                key={msgId}
                groupMemberDetails={groupMemberDetails}
                requestReplyMessage={requestReplyMessage}
                deliveredType={deliveredType}
                messageContent={msgBody}
                messageAction={messageAction}
                closeMessageOption={closeMessageOption}
                viewOriginalMessage={viewOriginalMessage}
                vCardData={data}
                messageObject={msg}
                jid={jid}
                addionalnfo={addionalnfo}
                messageInfoOptions={true}
                chatType={chatType}
                pageType={"conversation"}
                handleTranslateLanguage={handleTranslateLanguage}
                handleShowCallScreen={handleShowCallScreen}
                handleMediaShow={props.handleMediaShow}
            />) : (
            <DeletedMessage
                closeMessageOption={closeMessageOption}
                messageInfoOptions={true}
                addionalnfo={addionalnfo}
                key={msgId}
                vCardData={data}
                messageObject={msg}
                messageAction={messageAction}
                chatType={chatType}
            />
            );
        });
    };

    const messageToDisplay = (groupedMessages) =>
        groupedMessages.map((splitedMessage) => iterateArrayOfTemplate(splitedMessage));

    const dateBlock = (messageInDate, date) => {
        const groupedMessages = groupByTime(messageInDate, (singleImage) => new Date(singleImage.dateString).getTime());
        return (
            <React.Fragment key={date}>
                <div className="chatDate">
                    <span>{date && convertDateFormat(date)}</span>
                </div>
                {messageToDisplay(groupedMessages)}
            </React.Fragment>
        );
    };
    

    const constructMessageTemplate = () => {
        const { chatmessages } = props;
        const updatedMessage = groupBy(chatmessages, (date) => (convertUTCDateToLocalDate(date.createdAt) || "").split(/\s/)[0]);
        return Object.keys(updatedMessage).map((messageInDate) => {
            const { [messageInDate]: splitBlockByDate } = updatedMessage;
            return dateBlock(splitBlockByDate, messageInDate);
        });
    };

    const templates = constructMessageTemplate();
    return <React.Fragment>{templates || null}</React.Fragment>;
}

export default scrollComponent(ChatTemplate);
